import React from 'react'
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useState } from "react";
import Loading from "../components/loading/Loading";

function ManageUser() {
    const [isLoading, setLoading] = useState(false);
    return (
        <>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"Policy Tracking"} />
        <Menu
            parentmenu={"userManagement"}
            activemenu={"infoManageUser"}
        />
        <div className="content-wrapper">
            <div className="container-fluid  pdb-page">
                <h1>Manage User</h1>
            </div>
        </div>
        <Footer/>
        </>
    )
}

export default ManageUser